import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import * as logEntryActions from '../actions/logEntryActionCreators';

class CommanderConsoleWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            command: "",
            usedCommands: [],
            commandIndex: -1,
            cachedCommand: "",
            logEntriesByDate: this.props.logEntriesByDate,
            logEntries: this.props.logEntries
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        this.focusCommand();
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            logEntriesByDate: this.props.logEntriesByDate
        });
    }

    // EVENT HANDLERS

    handleClose = () => {
        //this.props.dispatch(logEntryActions.clearCommander()); //doesn't exists
        this.props.handleClose();
    }

    handleCommandChange = (event) => {
        this.setState({
            command: event.target.value
        });
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            this.executeCommand();
        }

        keyEvent.stopPropagation();
    }

    handleKeyUp = (keyEvent) => {
        if (keyEvent.key === "Escape") {
            this.handleClose();
        }

        if (keyEvent.key === "Tab") {
            this.focusCommand();
        }

        if (keyEvent.key === "ArrowUp") {
            this.previousCommand();
        }

        if (keyEvent.key === "ArrowDown") {
            this.nextCommand();
        }

        keyEvent.stopPropagation();
    }

    handleRequestHide = () => {

    }

    // OTHER METHODS

    createLogEntry = (logEntry) => {
        this.props.dispatch(logEntryActions.create(logEntry));
    }

    focusCommand = () => {
        ReactDOM.findDOMNode(this.refs.commandInput).focus();
    }

    executeCommand = () => {
        let command = this.state.command.trim().toLowerCase();

        if (command === "" && this.state.logEntries.length == 0) {
            return;
        }

        if (command === "save" || command === "ok" || (command === "" && this.state.logEntries.length > 0)) {
            this.saveLogEntries();
            this.handleClose();
        } else if (command === "quit" || command === "bye" || command === "exit" || command === "close") {
            this.handleClose();
        } else {
            this.props.dispatch(logEntryActions.commandCreate(command));

            setTimeout(() => {
                this.state.usedCommands.push(this.state.command);

                this.state.command = "";
                this.forceUpdate();
            }, 250);
        }
    }

    nextCommand = () => {
        if (this.state.commandIndex == -1) {
            return;
        }

        if (this.state.commandIndex == this.state.usedCommands.length - 1) {
            this.setState({
                command: this.state.cachedCommand,
                commandIndex: -1
            });
        } else {
            this.setState({
                command: this.state.usedCommands[this.state.commandIndex + 1],
                commandIndex: this.state.commandIndex + 1
            });
        }
    }

    previousCommand = () => {
        if (this.state.commandIndex == 0) {
            return 0;
        }

        if (this.state.commandIndex == -1) {
            this.setState({
                cachedCommand: this.state.command,
                commandIndex: this.state.usedCommands.length - 1,
                command: this.state.usedCommands[this.state.usedCommands.length - 1]
            });
        } else {
            this.setState({
                command: this.state.usedCommands[this.state.commandIndex - 1],
                commandIndex: this.state.commandIndex - 1
            });
        }

    }

    saveLogEntries = () => {

        for (let i = 0; i < this.state.logEntries.length; i++) {
            let logEntry = this.state.logEntries[i];
            let task;
            for (let j = 0; j < this.props.tasks.length; j++) {
                if (logEntry.task.parent) {
                    if (logEntry.task.parent.name === this.props.tasks[j].projectName && logEntry.task.name === this.props.tasks[j].name) {
                        task = this.props.tasks[j];
                        break;
                    }
                } else {
                    if (logEntry.task.name === this.props.tasks[j].name) {
                        task = this.props.tasks[j];
                        break;
                    }
                }
            }

            let monthString = logEntry.date.monthValue < 10 ? "0" + logEntry.date.monthValue : logEntry.date.monthValue;
            let dayString = logEntry.date.dayOfMonth < 10 ? "0" + logEntry.date.dayOfMonth : logEntry.date.dayOfMonth;
            let logEntryDate = logEntry.date.year + "-" +  monthString + "-" + dayString;

            let startTimeString = null;
            if (logEntry.startTime) {
                let hourString = logEntry.startTime.hour < 10 ? "0" + logEntry.startTime.hour : logEntry.startTime.hour;
                let minuteString = logEntry.startTime.minute < 10 ? "0" + logEntry.startTime.minute : logEntry.startTime.minute;
                startTimeString = hourString + ":" + minuteString;
            }

            let createdLogEntry = {
                taskID: task.id,
                taskName: logEntry.task.name,
                projectName: task.projectName,
                color: task.color,
                duration: logEntry.duration,
                overtime: logEntry.overtime,
                date: logEntryDate,
                description: logEntry.description,
                startTime: startTimeString,
                status: "DRAFT",
                lastModifiedAt: moment().format("YYYY-MM-DD[T]H:mm:ss"),
                lastModifiedByUser: this.props.currentUser.givenName + " " + this.props.currentUser.surname + " (" + this.props.currentUser.username + ")",
                userID: this.props.currentUser.id
            };

            setTimeout(this.createLogEntry.bind(this, createdLogEntry), i*100);
        }
    }

    // RENDER METHOD

    render = () => {
        let logEntriesString = "";

        this.state.logEntries.map(logEntry => {
            let monthString = logEntry.date.monthValue < 10 ? "0" + logEntry.date.monthValue : logEntry.date.monthValue;
            let dayString = logEntry.date.dayOfMonth < 10 ? "0" + logEntry.date.dayOfMonth : logEntry.date.dayOfMonth;
            let logEntryDate = logEntry.date.year + "-" +  monthString + "-" + dayString;

            let formattedTime = logEntryDate + " - " + Math.trunc(logEntry.duration / 60) + "h ";
            if (logEntry.duration % 60) {
                formattedTime += parseFloat(logEntry.duration % 60, 0) + "min";
            }
            if (logEntry.duration == null) {
                formattedTime = logEntryDate + " - Fill";
            }
            if (logEntry.overtime) {
                formattedTime += " overtime";
            }
            if (logEntry.description) {
                formattedTime += "\n" + logEntry.description;
            }

            let taskString = logEntry.task.parent ? logEntry.task.parent.name : "Floating task";
            taskString += " - " + logEntry.task.name;
            logEntriesString += taskString + "\n" + formattedTime + "\n\n";
        });

        logEntriesString = logEntriesString.trim();

        return (
            <Modal show={true} onKeyPress={this.handleKeyPress} onKeyUp={this.handleKeyUp} className="modal fade" tabIndex="-1" role="dialog" onRequestHide={this.handleRequestHide}>
                <div className="modal-dialog new-log-entry">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={this.handleClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title" id="myModalLabel">Tashi Commander Beta</h4>
                        </div>
                        <div className="modal-body">
                            {
                                this.state.logEntries.length > 0 ?
                                <textarea disabled value={logEntriesString} className="form-control" rows={Math.min(this.state.logEntries.length * 3, 9)} style={{resize : "vertical"}}>
                                </textarea>
                                : null
                            }

                            <div className="row">
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" disabled style={{cursor : "text"}} value={this.state.lastCommandOutput} placeholder="Last command status"/>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12">
                                    <input type="text" ref="commandInput" className="form-control" value={this.state.command} onChange={this.handleCommandChange} placeholder="Commands go here..."/>
                                </div>
                                <button type="button" onFocus={this.focusCommand} style={{marginLeft : "0px", "margin" : "0px", "padding" : "0px", "height" : "0px", "width" : "0px", "background": "transparent", "border" : "none"}}/>
                            </div>

                        </div>
                    </div>
                </div>

            </Modal>
        );
    }
}

CommanderConsoleWidget.propTypes = {
    currentUser: PropTypes.object,
    dates: PropTypes.array,
    dispatch: PropTypes.func,
    handleClose: PropTypes.func,
    logEntriesByDate: PropTypes.array,
    tasks: PropTypes.array
};

CommanderConsoleWidget.defaultProps = {
    logEntriesByDate: [[], [], [], [], [], [], []]
};

const mapStateToProps = (state) => {
    let logEntries = state.logEntries.commanderCreatedEntries;

    for (let i = 0; i < logEntries.length; i++) {
        let logEntry = logEntries[i];
        if (logEntry.duration === null) {
            let monthString = logEntry.date.monthValue < 10 ? "0" + logEntry.date.monthValue : logEntry.date.monthValue;
            let dayString = logEntry.date.dayOfMonth < 10 ? "0" + logEntry.date.dayOfMonth : logEntry.date.dayOfMonth;
            let logEntryDate = logEntry.date.year + "-" +  monthString + "-" + dayString;

            let dateIndex = -1;
            for (let j = 0; j < this.props.dates.length; j++) {
                if (this.props.dates[j].format("YYYY-MM-DD") === logEntryDate) {
                    dateIndex = j;
                    break;
                }
            }

           if (dateIndex == -1) {
                continue;
            }

            let timeLoggedOnDate = 0;
            for (let j = 0; j < this.state.logEntriesByDate[dateIndex].length; j++) {
                if (!this.state.logEntriesByDate[dateIndex][j].overtime) {
                    timeLoggedOnDate += this.state.logEntriesByDate[dateIndex][j].duration;
                }
            }

            if (timeLoggedOnDate < 480) {
                logEntries[i].duration = 480 - timeLoggedOnDate;
            } else {
                logEntries.splice(i, 1);
                i--;
            }
        }
    }

    return {
        currentUser: state.users.currentUser,
        logEntries: logEntries,
        lastCommandOutput: logEntries.length > 0 ?
           "Prepared " + logEntries.length + " log records. Press Enter to confirm." :
           state.logEntries.error ?
             state.logEntries.commanderErrorMsg :
             "What is your command?"
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommanderConsoleWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/CommanderConsoleWidget.js
 **/